import React from 'react';

/**
 * AttenderFields (S1-AC10 / S4-AC6) — OPTIONAL attender / next-of-kin block:
 * name · relation · mobile. Used by the AdmitPatientForm AND the desk
 * "Capture/edit attender" dialog (incl. on emergency rows). A PARTIAL block
 * (name only) is valid — no cross-field reactions, no required fields (absent ≡
 * null per S1-AC8).
 *
 * Controlled: `value = { name, relation, mobile }`, `onChange(next)`.
 */
export default function AttenderFields({ value, onChange, idPrefix = 'attender' }) {
  const v = value || {};
  const set = (field) => (e) => onChange({ ...v, [field]: e.target.value });

  const inputCls =
    'w-full px-2.5 py-2 rounded-lg border border-slate-300 dark:border-slate-600 ' +
    'bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100 text-sm ' +
    'focus:outline-none focus:ring-2 focus:ring-teal-500';
  const labelCls = 'block text-xs font-medium text-slate-500 dark:text-slate-400 mb-1';

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid="attender-fields">
      <div>
        <label className={labelCls} htmlFor={`${idPrefix}-name`}>Attender name</label>
        <input
          id={`${idPrefix}-name`}
          className={inputCls}
          placeholder="e.g. Sunita Sharma"
          value={v.name || ''}
          onChange={set('name')}
        />
      </div>
      <div>
        <label className={labelCls} htmlFor={`${idPrefix}-relation`}>Relation</label>
        <input
          id={`${idPrefix}-relation`}
          className={inputCls}
          placeholder="e.g. Spouse"
          value={v.relation || ''}
          onChange={set('relation')}
        />
      </div>
      <div>
        <label className={labelCls} htmlFor={`${idPrefix}-mobile`}>Attender mobile</label>
        <input
          id={`${idPrefix}-mobile`}
          className={inputCls}
          inputMode="tel"
          placeholder="+91…"
          value={v.mobile || ''}
          onChange={set('mobile')}
        />
      </div>
    </div>
  );
}
